import React, { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import banner from "../assets/banner.png";
import certificate from "../assets/certificate.png";
import loadingg from "../assets/loading.png";
import banner1 from "../assets/banner1.png";
import image1 from "../assets/image1.png";
import image2 from "../assets/image2.png";
import image3 from "../assets/image3.png";
import c1 from "../assets/c1.png";
import c2 from "../assets/c2.png";
import c3 from "../assets/c3.png";
import c4 from "../assets/c4.png";
import c5 from "../assets/c5.png";
import c6 from "../assets/c6.png";
import c7 from "../assets/c7.png";
import c8 from "../assets/c8.png";
import p1 from "../assets/p1.jpg";
import p2 from "../assets/p2.jpg";
import p3 from "../assets/p3.jpg";
import p4 from "../assets/p4.jpg";
import p5 from "../assets/p5.jpg";
import p6 from "../assets/p6.jpg";
import p7 from "../assets/p7.jpg";
import p8 from "../assets/p8.jpg";
import I1 from "../assets/I1.png";
import I2 from "../assets/I2.png";
import I3 from "../assets/I3.png";
import PhoneInput from "react-phone-input-2";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import "react-phone-input-2/lib/material.css";
import LocalFloristIcon from "@mui/icons-material/LocalFlorist";
import DoneIcon from "@mui/icons-material/Done";
import { motion } from "framer-motion";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Header from "./Header";
import Footer from "./Footer";

const faqs = [
  {
    question: "What is covered in the basics of astrology?",
    answers: [
      "Introduction to astrology fundamentals",
      "Understanding sun, moon, and rising signs",
      "How planets influence daily life",
    ],
  },
  {
    question: "Do you teach planetary influences?",
    answers: [
      "Detailed study of planetary positions",
      "Impact of planets on relationships",
      "Effects on career and personal growth",
    ],
  },
  {
    question: "Will I learn about zodiac signs?",
    answers: [
      "Characteristics of all 12 zodiac signs",
      "How signs affect personality",
      "Matching compatibility of signs",
    ],
  },
  {
    question: "Do you teach Vedic astrology?",
    answers: [
      "Basics of Vedic charts",
      "House system and planetary placements",
      "Traditional wisdom in modern context",
    ],
  },
  {
    question: "Is birth chart analysis included?",
    answers: [
      "Creating birth charts step by step",
      "Reading and interpreting charts",
      "Practice with real-world examples",
    ],
  },
  {
    question: "Do I get practical assignments?",
    answers: [
      "Case studies for practice",
      "Hands-on assignments",
      "Feedback from mentors",
    ],
  },
  {
    question: "Are remedies and solutions covered?",
    answers: [
      "Astrological remedies",
      "Gemstone guidance",
      "Practical lifestyle changes",
    ],
  },
  {
    question: "Do I get certification?",
    answers: [
      "Yes, on successful completion",
      "Recognized by the institute",
      "Useful for career in astrology",
    ],
  },
  {
    question: "Can beginners join this course?",
    answers: [
      "No prior knowledge required",
      "Step-by-step learning process",
      "Guidance throughout the course",
    ],
  },
  {
    question: "Do you cover modern astrology trends?",
    answers: [
      "Psychological astrology",
      "Modern interpretations of charts",
      "Blending ancient with modern methods",
    ],
  },
];
const faqss = [
  {
    question: "Do you teach Vedic astrology?",
    answers: [
      "Basics of Vedic charts",
      "House system and planetary placements",
      "Traditional wisdom in modern context",
    ],
  },
  {
    question: "Is birth chart analysis included?",
    answers: [
      "Creating birth charts step by step",
      "Reading and interpreting charts",
      "Practice with real-world examples",
    ],
  },
  {
    question: "Do I get practical assignments?",
    answers: [
      "Case studies for practice",
      "Hands-on assignments",
      "Feedback from mentors",
    ],
  },
  {
    question: "Are remedies and solutions covered?",
    answers: [
      "Astrological remedies",
      "Gemstone guidance",
      "Practical lifestyle changes",
    ],
  },
  {
    question: "Do I get certification?",
    answers: [
      "Yes, on successful completion",
      "Recognized by the institute",
      "Useful for career in astrology",
    ],
  },
  {
    question: "Can beginners join this course?",
    answers: [
      "No prior knowledge required",
      "Step-by-step learning process",
      "Guidance throughout the course",
    ],
  },
  {
    question: "Do you cover modern astrology trends?",
    answers: [
      "Psychological astrology",
      "Modern interpretations of charts",
      "Blending ancient with modern methods",
    ],
  },
];
const courses = [
  {
    image: c1,
    title: "Vastu Course",
    description:
      "Vastu is an old Indian investigation of architecture and structures that help make an appropriate setting or a spot to live and work in a most legitimate way, taking advantage of the benefits given generally",
  },
  {
    image: c2,
    title: "Astrology Course",
    description:
      "Vastu is an old Indian investigation of architecture and structures that help make an appropriate setting or a spot to live and work in a most legitimate way, taking advantage of the benefits given generally",
  },
  {
    image: c3,
    title: "Tarot Card",
    description:
      "Vastu is an old Indian investigation of architecture and structures that help make an appropriate setting or a spot to live and work in a most legitimate way, taking advantage of the benefits given generally",
  },
  {
    image: c4,
    title: "Yoga Course",
    description:
      "Vastu is an old Indian investigation of architecture and structures that help make an appropriate setting or a spot to live and work in a most legitimate way, taking advantage of the benefits given generally",
  },
  {
    image: c5,
    title: "Advanced Vastu",
    description:
      "Vastu is an old Indian investigation of architecture and structures that help make an appropriate setting or a spot to live and work in a most legitimate way, taking advantage of the benefits given generally",
  },
  {
    image: c6,
    title: "Numerology",
    description:
      "Vastu is an old Indian investigation of architecture and structures that help make an appropriate setting or a spot to live and work in a most legitimate way, taking advantage of the benefits given generally",
  },
  {
    image: c7,
    title: "Palmistry",
    description:
      "Vastu is an old Indian investigation of architecture and structures that help make an appropriate setting or a spot to live and work in a most legitimate way, taking advantage of the benefits given generally",
  },
  {
    image: c8,
    title: "Meditation Course",
    description:
      "Vastu is an old Indian investigation of architecture and structures that help make an appropriate setting or a spot to live and work in a most legitimate way, taking advantage of the benefits given generally",
  },
];
const popular = [
  {
    image: p1,
    title: "Learn Astrology (Signs, Stars, Planets)",
    views: "2.5M",
    channel: "RVA Telugu",
  },
  {
    image: p2,
    title: "How to Read Horoscope",
    views: "822K",
    channel: "RVA Telugu",
  },
  {
    image: p3,
    title: "Dasha Phalithalu | Ep15",
    views: "278K",
    channel: "RVA Telugu",
  },
  {
    image: p4,
    title: "Lagna Yoga Karakulu | Ep14",
    views: "394K",
    channel: "RVA Telugu",
  },
  {
    image: p5,
    title: "Learn Western Astrology in Telugu",
    views: "22K",
    channel: "RVA Telugu",
  },
  {
    image: p6,
    title: "Raja Yoga in Astrology | Ep37",
    views: "170K",
    channel: "RVA Telugu",
  },
  {
    image: p7,
    title: "Introduction to Nakshatras (Stars)",
    views: "107K",
    channel: "RVA Telugu",
  },
  {
    image: p8,
    title: "Learn KP Astrology in Telugu",
    views: "101K",
    channel: "RVA Telugu",
  },
];

const Courses = () => {
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [expanded1, setExpanded1] = useState(false);
  const [expanded2, setExpanded2] = useState(false);
  const [expanded3, setExpanded3] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleChange1 = (panel) => (event, isExpanded) => {
    setExpanded1(isExpanded ? panel : false);
  };
  const handleChange2 = (panel) => (event, isExpanded) => {
    setExpanded2(isExpanded ? panel : false);
  };
  const handleChange3 = (panel) => (event, isExpanded) => {
    setExpanded3(isExpanded ? panel : false);
  };

  const handleClick = () => {
    setLoading(true); // start loading

    setTimeout(() => {
      setChecked((prev) => !prev); // toggle checked state
      setLoading(false); // stop loading
    }, 500); // 0.5s delay
  };

  const cardVariants = {
    hidden: { opacity: 0, scale: 0.5, y: 50 },
    visible: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.8 } },
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.3 },
    },
  };
  const itemVariantsLeft = {
    hidden: { opacity: 0, x: -30 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8 } },
  };

  const itemVariantsRight = {
    hidden: { opacity: 0, x: 30 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8 } },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <>
      <Box sx={{ overflow: "hidden" }}>
        <Header />
        <Box
          sx={{
            backgroundImage: `url(${banner1})`,
            backgroundPosition: "center",
            backgroundRepeat: "repeat",
          }}
        >
          <Grid
            container
            spacing={5}
            sx={{
              backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${banner})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              display: "flex",
              justifyContent: "space-between",
              p: { xs: 2, md: 6 },
              mt: 10,
            }}
          >
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                // alignItems: "center",
                color: "#fff",
                textAlign: { xs: "center", md: "left" },
                // mb: { xs: 4, md: 0 },
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: 20, md: 36 },
                  fontWeight: "bold",
                }}
              >
                Learn Astrology Like Never Before
              </Typography>
              <Box sx={{ height: 4, bgcolor: "#ffc20f", width: "200px", mb: 2, borderRadius: 4 }} />

              <Typography
                sx={{
                  fontSize: { xs: 16, md: 16 },
                  fontWeight: 700,
                  mt: 2,
                  textAlign: "left",
                }}
              >
                Be a Professional Astrologer
              </Typography>
              <Typography sx={{ mt: 2 }}>
                We welcome you to enroll in our interesting online Astrology
                course, where you will explore the fascinating universe of
                cosmic mysteries in simple ways. Get ready to explore the cosmic
                connections that influence our lives and learn about the secrets
                Astrology has to offer.
              </Typography>
              <Button
                variant="contained"
                sx={{
                  width: 200,
                  mt: 3,
                  px: 4,
                  py: 1.5,
                  fontWeight: "bold",
                  backgroundColor: "#ffc20f",
                  color: "#000",
                  "&:hover": { backgroundColor: "#6d1675", color: "#fff" },
                }}
              >
                Call Us Now
              </Button>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  width: 450,
                  bgcolor: "#fff",
                  p: 4,
                  borderRadius: 2,
                  boxShadow: 3,
                }}
              >
                <Typography
                  sx={{
                    fontSize: 20,
                    fontWeight: "bold",
                    // textAlign: "center",
                    color: "#6d1675",
                    mb: 0.5
                  }}
                >
                  Fill Out This Form To Get Course Details
                </Typography>
                <Box sx={{ height: 3, bgcolor: "#ffc20f", width: "180px", mb: 3, borderRadius: 4 }} />

                <Typography sx={{ fontWeight: "bold", mb: -1, mt: 1, color: "#6d1675" }}>
                  Your Name <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  margin="normal"
                  placeholder="Enter Your Full Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  sx={{
                    "& .MuiInputBase-root": { height: 50, borderRadius: 3 },
                  }}
                />

                <Typography sx={{ fontWeight: "bold", mb: 2, mt: 1, color: "#6d1675" }}>
                  Contact No. <span style={{ color: "red" }}>*</span>
                </Typography>
                <PhoneInput
                  country={"in"} // default country India
                  value={phone}
                  onChange={(phone) => setPhone(phone)}
                  inputStyle={{
                    width: "100%",
                    height: "50px",
                    borderRadius: "8px",
                    border: "1px solid #ccc", // normal border
                    fontSize: "16px",
                  }}
                  buttonStyle={{
                    border: "none", // no extra border for flag dropdown
                    background: "transparent",
                  }}
                  containerStyle={{
                    width: "100%",
                  }}
                  dropdownStyle={{
                    borderRadius: "8px",
                  }}
                />

                <Box>
                  <Typography sx={{ fontWeight: "bold", mb: -1, mt: 1, color: "#6d1675" }}>
                    Your Email <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder="Enter Your Email"
                    margin="normal"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    sx={{
                      "& .MuiInputBase-root": { height: 50, borderRadius: 3 },
                    }}
                  />
                </Box>
                <Box
                  sx={{
                    mt: 2,
                    p: 2,
                    border: "1px solid #ccc",
                    borderRadius: 1,
                    width: 200,
                    backgroundColor: "#f9f9f9",
                    boxShadow: 1,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <FormControlLabel
                      control={
                        <Box
                          sx={{
                            position: "relative",
                            display: "inline-flex",
                            width: 28,
                            height: 28,
                          }}
                        >
                          {!loading && (
                            <Checkbox
                              checked={checked}
                              onChange={handleClick}
                              sx={{
                                color: "grey",
                                "&.Mui-checked": { color: "green" },
                                width: 28,
                                height: 28,
                              }}
                            />
                          )}
                          {loading && (
                            <CircularProgress
                              size={30}
                              sx={{ position: "absolute", top: 0, left: 0 }}
                            />
                          )}
                        </Box>
                      }
                      label="I am not a robot"
                    />
                    <img
                      src={loadingg}
                      alt="Loading"
                      style={{ width: 30, height: 20 }}
                    />
                  </Box>
                </Box>

                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    mt: 3,
                    py: 1.5,
                    backgroundColor: "#6d1675",
                    fontWeight: "bold",
                    borderRadius: 20,
                    "&:hover": { backgroundColor: "#ffc20f" },
                  }}
                >
                  Get Course Details
                </Button>
              </Box>
            </Grid>
          </Grid>
          <Box
            component={motion.div}
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.2 }}
            sx={{
              p: { xs: 2, md: 8 },
            }}
          >
            <motion.div variants={itemVariants}>
              <Typography
                sx={{
                  fontSize: 30,
                  fontWeight: "bold",
                  mb: 0,
                  textAlign: "center",
                  color: "#6d1675"
                }}
              >
                How will your{" "}
                <span style={{ color: "#ffc20f" }}>Certificate</span> look Like
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  maxWidth: 300,
                  mx: "auto",
                }}
              >
                <Box sx={{ flex: 1, height: 3, bgcolor: "#6d1675" }} />

                <Box
                  sx={{
                    px: 2,
                    //   bgcolor: "#fcf6eb",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <LocalFloristIcon sx={{ fontSize: 28, color: "#ffc20f" }} />
                </Box>

                <Box sx={{ flex: 1, height: 3, bgcolor: "#6d1675" }} />
              </Box>
            </motion.div>

            <Grid container spacing={4}>
              <Grid
                component={motion.div}
                variants={itemVariantsLeft}
                size={{ xs: 12, md: 6 }}
                sx={{ textAlign: "center" }}
              >
                <img
                  src={certificate}
                  alt="certificate"
                  style={{ width: "100%", height: "auto" }}
                />
              </Grid>

              <Grid
                component={motion.div}
                variants={itemVariantsRight}
                size={{ xs: 12, md: 6 }}
                sx={{ mt: 3 }}
              >
                <Typography sx={{ fontSize: 20, fontWeight: "bold" }}>
                  Earn a Certificate from the All India Institute of Occult
                  Science to Start Your Astrological Wisdom Journey!
                </Typography>
                <Typography sx={{ mt: 2, fontSize: 15, fontWeight: "500" }}>
                  Are you willing to explore the fascinating world of Vedic
                  Astrology? Look nowhere else! Welcome to the All India
                  Institute of Occult Science, the top organization providing an
                  Astrology Course. Get a prestigious certificate!
                </Typography>
                <Typography sx={{ fontSize: 20, fontWeight: "bold", mt: 2 }}>
                  Experienced Teachers:
                </Typography>
                <Typography sx={{ mt: 2, fontSize: 15, fontWeight: "500" }}>
                  Learn from highly experienced teachers who have experience of
                  more than 10 years in teaching and implementing.
                </Typography>
                <Typography sx={{ fontSize: 20, fontWeight: "bold", mt: 2 }}>
                  Practical Training:
                </Typography>
                <Typography sx={{ mt: 2, fontSize: 15, fontWeight: "500" }}>
                  Gain real-world experience while learning through case
                  studies.
                </Typography>
                <Typography sx={{ fontSize: 20, fontWeight: "bold", mt: 2 }}>
                  Interactive Learning Environment:
                </Typography>
                <Typography sx={{ mt: 2, fontSize: 15, fontWeight: "500" }}>
                  Engage in live discussions, participate in group discussions,
                  and connect with your classmates on discussion forums.
                </Typography>
                <Typography sx={{ fontSize: 20, fontWeight: "bold", mt: 2 }}>
                  Continued Support:
                </Typography>
                <Typography sx={{ mt: 2, fontSize: 15, fontWeight: "500" }}>
                  Take advantage of ongoing support after completing the course.
                  Are you ready to start your life-changing Astrological
                  journey?
                </Typography>
                <Typography sx={{ mt: 1, fontSize: 15, fontWeight: "500" }}>
                  Enroll in the All India Institute of Occult Sciences Astrology
                  course.
                  <span style={{ fontWeight: "bold" }}>
                    {" "}
                    Join now to learn Vedic Astrology.
                  </span>
                </Typography>
              </Grid>
            </Grid>
          </Box>
          <Grid
            container
            spacing={5}
            component={motion.div}
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.2 }}
            sx={{ bgcolor: "#ffe9df", p: { xs: 2, md: 8 } }}
          >
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{ mt: 0 }}
              component={motion.div}
              variants={itemVariantsLeft}
            >
              <img
                src={image1}
                alt="certificate"
                style={{
                  border: "4px solid #fff",
                  borderRadius: 20,
                  width: "100%",
                  maxWidth: 550,
                  height: "auto",
                }}
              />
            </Grid>

            <Grid
              size={{ xs: 12, md: 6 }}
              component={motion.div}
              variants={itemVariantsRight}
            >
              <Typography sx={{ fontSize: 30, fontWeight: "bold", color: '#6d1675', textAlign: 'center' }}>
                About Our <span style={{ color: "#ffc20f" }}>Astrology</span>{" "}
                Course
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  maxWidth: 300,
                  mx: "auto",
                }}
              >
                <Box sx={{ flex: 1, height: 3, bgcolor: "#6d1675" }} />

                <Box
                  sx={{
                    px: 2,
                    //   bgcolor: "#fcf6eb",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <LocalFloristIcon sx={{ fontSize: 28, color: "#ffc20f" }} />
                </Box>

                <Box sx={{ flex: 1, height: 3, bgcolor: "#6d1675" }} />
              </Box>

              {/* Paragraph */}
              <Typography
                sx={{
                  mt: 2,
                  fontSize: 15,
                  fontWeight: "500",
                  textAlign: "justify",
                }}
              >
                Our Astrology course is the perfect opportunity for you to do
                just that! This comprehensive course will give you a greater
                understanding of the language of the stars...
              </Typography>

              {/* Bullet points */}
              <Box sx={{ mt: 3 }}>
                {[
                  "Learn more about the influence of cosmic patterns on our lives and the appealing universe they inhabit.",
                  "Learn everything there is to know about astrological meaning, planetary influences, and birth charts.",
                  "Learn about the roots of astrology in an updated and accessible way.",
                  "Well-prepared curriculum by top astrologers and subject matter experts.",
                ].map((text, i) => (
                  <Box
                    key={i}
                    sx={{ display: "flex", alignItems: "center", mb: 1.5 }}
                  >
                    <DoneIcon sx={{ color: "#6d1675", mr: 1, fontSize: 20 }} />
                    <Typography sx={{ fontSize: 13 }}>{text}</Typography>
                  </Box>
                ))}
              </Box>

              {/* Button */}
              <Button
                sx={{
                  mt: 3,
                  px: 4,
                  py: 1.5,
                  fontWeight: "bold",
                  backgroundColor: "#ffc20f",
                  color: "#000",
                  "&:hover": { backgroundColor: "#6d1675", color: "#fff" },
                }}
              >
                Book Live Demo Session
              </Button>
            </Grid>
          </Grid>
          <Box
            sx={{
              p: { xs: 2, md: 8 },
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box sx={{ textAlign: "center", mb: 5 }}>
              <Typography sx={{ fontSize: 30, fontWeight: "bold", mb: 0, color: "#6d1675" }}>
                Methods Of Teaching{" "}
                <span style={{ color: "#ffc20f" }}>Astrology</span> :
              </Typography>

              {/* Divider with flower */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  maxWidth: 300,
                  mx: "auto",
                }}
              >
                <Box sx={{ flex: 1, height: 3, bgcolor: "#6d1675" }} />
                <Box sx={{ px: 2, display: "flex", alignItems: "center" }}>
                  <LocalFloristIcon sx={{ fontSize: 28, color: "#ffc20f" }} />
                </Box>
                <Box sx={{ flex: 1, height: 3, bgcolor: "#6d1675" }} />
              </Box>

              {/* Cards */}
              <Grid container spacing={4} sx={{ mt: 5 }}>
                {[
                  {
                    img: I1,
                    title: "Scientific Method",
                    text: "This method looks at data and patterns in astrology. It connects astrology to science, helping you use it in real life.",
                  },
                  {
                    img: I2,
                    title: "Vedic Method",
                    text: "This method uses ancient Indian teachings to read astrology charts. It focuses on how planets influence our lives according to Vedic wisdom.",
                  },
                  {
                    img: I3,
                    title: "Our Unique Method",
                    text: "We combine both scientific and Vedic methods. This way, you learn through real examples, practice, and personal help to truly understand astrology.",
                  },
                ].map((card, index) => (
                  <Grid size={{ xs: 12, md: 4 }} key={index}>
                    <motion.div
                      variants={cardVariants}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: false, amount: 0.2 }}
                    >
                      <Card
                        sx={{
                          p: 2,
                          backgroundColor: "#fff",
                          boxShadow: 5,
                          borderRadius: 5,
                          textAlign: "center",
                          height: 250,
                        }}
                      >
                        <CardContent sx={{ display: 'flex', flexDirection: "column", alignItems: "center" }}>
                          <Box
                            sx={{
                              bgcolor: "#fff5e5",
                              borderRadius: "50%",
                              p: 1,
                              width: 60,
                              height: 60,
                              mx: "auto",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              animation: "float 3s ease-in-out infinite",
                              "@keyframes float": {
                                "0%": { transform: "translateY(0px)" },
                                "50%": { transform: "translateY(-20px)" },
                                "100%": { transform: "translateY(0px)" },
                              },
                            }}
                          >
                            <img
                              src={card.img}
                              alt={card.title}
                              style={{ width: 60, height: 60 }}
                            />
                          </Box>
                          <Typography
                            sx={{
                              fontSize: 20,
                              fontWeight: "bold",
                              color: "#6b175f",
                              mt: 2,
                            }}
                          >
                            {card.title}
                          </Typography>
                          <Box sx={{ height: 3, bgcolor: "#ffc20f", width: "120px", }} />
                          <Typography sx={{ mt: 1, fontSize: 15 }}>
                            {card.text}
                          </Typography>
                        </CardContent>
                      </Card>
                    </motion.div>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Box>
          <Grid
            container
            spacing={5}
            sx={{
              background: `linear-gradient(
      to bottom,
      #ffeadf 0%,
      #ffe9df 25%,
      #fef1d9 50%,
      #fff8e6 75%,
      #fff7e5 100%
    )`,
              p: { xs: 2, md: 8 },
            }}
            component={motion.div}
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.2 }} // 👈 animate every time in view
          >
            {/* Image side */}
            <Grid size={{ xs: 12, md: 6 }} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: "center" }}>
              <motion.img
                src={image2}
                alt="certificate"
                variants={itemVariants}
                style={{
                  border: "4px solid #fff",
                  borderRadius: 20,
                  width: "100%",
                  maxWidth: 700,
                  height: "auto",
                }}
              />
            </Grid>

            {/* Text + Accordions side */}
            <Grid size={{ xs: 12, md: 6 }} sx={{ mt: 0 }}>
              <motion.div variants={itemVariants}>

                <Typography sx={{ fontSize: 30, fontWeight: "bold", color: '#6d1675', textAlign: 'center' }}>
                  What will you <span style={{ color: "#ffc20f" }}>learn</span>{" "}
                  with us?
                </Typography>


              </motion.div>

              {/* Divider with flower */}
              <motion.div variants={itemVariants}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    maxWidth: 300,
                    mx: "auto",
                  }}
                >
                  <Box sx={{ flex: 1, height: 3, bgcolor: "#6d1675" }} />

                  <Box
                    sx={{
                      px: 2,
                      //   bgcolor: "#fcf6eb",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <LocalFloristIcon sx={{ fontSize: 28, color: "#ffc20f" }} />
                  </Box>

                  <Box sx={{ flex: 1, height: 3, bgcolor: "#6d1675" }} />
                </Box>

              </motion.div>

              {/* Accordions */}
              <Box
                component={motion.div}
                variants={containerVariants}
                sx={{ mt: 4 }}
              >
                {faqs.map((faq, index) => (
                  <motion.div key={index} variants={itemVariants} >
                    <Accordion
                      expanded={expanded1 === index}
                      onChange={handleChange1(index)}
                      sx={{
                        backgroundColor: "#fff",
                        borderRadius: 4,
                        boxShadow: 2,
                        mb: 2,
                        "&:before": { display: "none" },
                      }}
                    >
                      <AccordionSummary
                        expandIcon={
                          expanded1 === index ? (
                            <RemoveIcon
                              sx={{ color: "#6d1675", fontSize: 28 }}
                            />
                          ) : (
                            <AddIcon sx={{ color: "#6d1675", fontSize: 28 }} />
                          )
                        }
                      >
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            fontSize: { xs: 15, md: 16 },
                          }}
                        >
                          {faq.question}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        {faq.answers.map((point, i) => (
                          <Box
                            key={i}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              mb: 1,
                            }}
                          >
                            <CheckCircleIcon
                              sx={{ color: "#6d1675", fontSize: 18, mr: 1 }}
                            />
                            <Typography>{point}</Typography>
                          </Box>
                        ))}
                      </AccordionDetails>
                    </Accordion>
                  </motion.div>
                ))}
              </Box>

              {/* Button */}

              <Button
                sx={{
                  mt: 3,
                  px: 4,
                  py: 1.5,
                  fontWeight: "bold",
                  backgroundColor: "#ffc20f",
                  color: "#000",
                  "&:hover": { backgroundColor: "#6d1675", color: "#fff" },
                }}
              >
                Download Course Syllabus
              </Button>
            </Grid>
          </Grid>
          <Box
            component={motion.div}
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.2 }}
            sx={{
              background: `linear-gradient(
            to bottom,
            #ffe9df 0%,
            #ffe9df 25%,
            #fef1d9 50%,
            #fff8e6 75%,
            #fff7e5 100%
          )`,
              p: { xs: 2, md: 8 },
            }}
          >
            <motion.div variants={itemVariants}>
              <Box
                sx={{
                  textAlign: "center",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography sx={{ fontSize: 30, fontWeight: "bold", color: "#6d1675" }}>
                  Why we are India's{" "}
                  <span style={{ color: "#ffc20f" }}>Best Institute</span>
                </Typography>

                {/* Divider with flower */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    maxWidth: 300,
                    mx: "auto",
                  }}
                >
                  <Box sx={{ flex: 1, height: 3, bgcolor: "#6d1675" }} />
                  <Box sx={{ px: 2, display: "flex", alignItems: "center" }}>
                    <LocalFloristIcon sx={{ fontSize: 28, color: "#ffc20f" }} />
                  </Box>
                  <Box sx={{ flex: 1, height: 3, bgcolor: "#6d1675" }} />
                </Box>

                <Typography
                  sx={{ fontSize: 16, fontWeight: "bold", mb: 1, mt: 1, color: "#6d1675" }}
                >
                  All India Institute Of Occult Science{" "}
                </Typography>


              </Box>
            </motion.div>
            <Grid container spacing={5} sx={{ mt: 2 }}>
              <Grid size={{ xs: 12, md: 6 }} sx={{ mt: 0 }}>
                <Box
                  component={motion.div}
                  variants={containerVariants}
                  sx={{ mt: 4 }}
                >
                  {faqss.map((faq, index) => (
                    <motion.div key={index} variants={itemVariants}>
                      <Accordion
                        key={index}
                        expanded={expanded2 === index}
                        onChange={handleChange2(index)}
                        sx={{
                          backgroundColor: "#fff",
                          borderRadius: 2,
                          boxShadow: 2,
                          mb: 2,
                          "&:before": { display: "none" },
                        }}
                      >
                        <AccordionSummary
                          expandIcon={
                            expanded2 === index ? (
                              <RemoveIcon
                                sx={{ color: "#6d1675", fontSize: 28 }}
                              />
                            ) : (
                              <AddIcon
                                sx={{ color: "#6d1675", fontSize: 28 }}
                              />
                            )
                          }
                        >
                          <Typography
                            sx={{
                              fontWeight: "bold",
                              fontSize: { xs: 15, md: 16 },
                            }}
                          >
                            {faq.question}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          {faq.answers.map((point, i) => (
                            <Box
                              key={i}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                mb: 1,
                              }}
                            >
                              <CheckCircleIcon
                                sx={{ color: "#6d1675", fontSize: 18, mr: 1 }}
                              />
                              <Typography>{point}</Typography>
                            </Box>
                          ))}
                        </AccordionDetails>
                      </Accordion>
                    </motion.div>
                  ))}
                </Box>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }} sx={{ display: 'flex', flexDirection: "column", justifyContent: 'center', alignItems: 'center' }}>
                <img
                  src={image2}
                  alt="certificate"
                  style={{
                    border: "4px solid #fff",
                    borderRadius: 20,
                    width: "100%",
                    maxWidth: 700,
                    height: "auto",
                  }}
                />
              </Grid>
            </Grid>
          </Box>
          <Box
            component={motion.div}
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.2 }}
            sx={{
              background: `linear-gradient(
            to bottom,
            #ffe9df 0%,
            #ffe9df 25%,
            #fef1d9 50%,
            #fff8e6 75%,
            #fff7e5 100%
          )`,
              p: { xs: 2, md: 8 },
            }}
          >
            <motion.div variants={itemVariants}>
              <Box
                sx={{
                  textAlign: "center",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >


                <Typography sx={{ fontSize: 30, fontWeight: "bold", color: "#6d1675" }}>
                  Benefits of Joining{" "}
                  <span style={{ color: "#ffc20f" }}>{" "}
                    Best Astrology Course{" "}</span>{" "}
                  in
                </Typography>

                {/* Divider with flower */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    maxWidth: 300,
                    mx: "auto",
                  }}
                >
                  <Box sx={{ flex: 1, height: 3, bgcolor: "#6d1675" }} />
                  <Box sx={{ px: 2, display: "flex", alignItems: "center" }}>
                    <LocalFloristIcon sx={{ fontSize: 28, color: "#ffc20f" }} />
                  </Box>
                  <Box sx={{ flex: 1, height: 3, bgcolor: "#6d1675" }} />
                </Box>

                <Typography
                  sx={{ fontSize: 16, fontWeight: "bold", mb: 1, mt: 1, color: "#6d1675" }}
                >
                  All India Institute Of Occult Science{" "}
                </Typography>



              </Box>
            </motion.div>
            <Grid container spacing={5} sx={{ mt: 2 }}>
              <Grid size={{ xs: 12, md: 6 }} sx={{ mt: 5, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <motion.div variants={itemVariants}>
                  <img
                    src={image3}
                    alt="certificate"
                    style={{
                      border: "4px solid #fff",
                      borderRadius: 20,
                      width: "100%",
                      maxWidth: 700,
                      height: "auto",
                    }}
                  />
                </motion.div>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }} sx={{ mt: 0 }}>
                <Box sx={{ mt: 4 }}>
                  {faqss.map((faq, index) => (
                    <motion.div key={index} variants={itemVariants}>
                      <Accordion
                        key={index}
                        expanded={expanded3 === index}
                        onChange={handleChange3(index)}
                        sx={{
                          backgroundColor: "#fff",
                          borderRadius: 2,
                          boxShadow: 2,
                          mb: 2,
                          "&:before": { display: "none" },
                        }}
                      >
                        <AccordionSummary
                          expandIcon={
                            expanded3 === index ? (
                              <RemoveIcon
                                sx={{ color: "#6d1675", fontSize: 28 }}
                              />
                            ) : (
                              <AddIcon
                                sx={{ color: "#6d1675", fontSize: 28 }}
                              />
                            )
                          }
                        >
                          <Typography
                            sx={{
                              fontWeight: "bold",
                              fontSize: { xs: 15, md: 16 },
                            }}
                          >
                            {faq.question}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          {faq.answers.map((point, i) => (
                            <Box
                              key={i}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                mb: 1,
                              }}
                            >
                              <CheckCircleIcon
                                sx={{ color: "#6d1675", fontSize: 18, mr: 1 }}
                              />
                              <Typography>{point}</Typography>
                            </Box>
                          ))}
                        </AccordionDetails>
                      </Accordion>
                    </motion.div>
                  ))}
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ p: { xs: 2, md: 8 } }}>
            <motion.div variants={itemVariants}>
              <Box
                sx={{
                  textAlign: "center",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography sx={{ fontSize: 30, fontWeight: "bold", color: "#6d1675" }}>
                  Explore Other
                  <span style={{ color: "#ffc20f" }}> Courses </span>{" "}
                </Typography>

                {/* Divider with flower */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    maxWidth: 300,
                    mx: "auto",
                  }}
                >
                  <Box sx={{ flex: 1, height: 3, bgcolor: "#6d1675" }} />
                  <Box sx={{ px: 2, display: "flex", alignItems: "center" }}>
                    <LocalFloristIcon sx={{ fontSize: 28, color: "#ffc20f" }} />
                  </Box>
                  <Box sx={{ flex: 1, height: 3, bgcolor: "#6d1675" }} />
                </Box>

              </Box>
            </motion.div>
            <Grid container spacing={3} sx={{ mt: 5 }}>
              {courses.map((course, index) => (
                <Grid
                  component={motion.div}
                  variants={itemVariants}
                  size={{ xs: 12, md: 3, sm: 6 }}
                  key={index}
                  sx={{ mb: 5 }}
                >
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    transition={{ duration: 0.3 }}
                  >
                    <Card
                      sx={{
                        height: "100%",
                        borderRadius: 3,
                        boxShadow: 3,
                        p: 1,
                        textAlign: "center",
                        cursor: "pointer",
                      }}
                    >
                      <Box sx={{ bgcolor: "#fbf8ee", borderRadius: 2, p: 1 }}>
                        <motion.img
                          src={course.image}
                          alt={course.title}
                          style={{
                            width: 100,
                            height: 150,
                            objectFit: "contain",
                            borderRadius: 10,
                          }}
                          whileHover={{ scale: 1.5 }}
                          transition={{ duration: 0.3 }}
                        />
                      </Box>
                      <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: "center" }}>
                        <Typography
                          variant="h6"
                          sx={{ fontWeight: "bold", color: "#6d1675", }}
                        >
                          {course.title}
                        </Typography>
                        <Box sx={{ height: 3, bgcolor: "#ffc20f", mb: 1, width: '120px' }} />
                        <Typography
                          variant="body2"
                          sx={{ mb: 2, lineHeight: 1.8 }}
                        >
                          {course.description}
                        </Typography>
                        <Button
                          variant="contained"
                          sx={{
                            backgroundColor: "#ffc20f",
                            color: "#6d1675",
                            fontWeight: "bold",
                            textTransform: "none",
                            "&:hover": {
                              backgroundColor: "#6d1675",
                              color: "#ffc20f",
                            },
                          }}
                        >
                          Get Course Details →
                        </Button>
                      </CardContent>
                    </Card>
                  </motion.div>
                </Grid>
              ))}
            </Grid>
          </Box>
          <Box
            component={motion.div}
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.2 }}
            sx={{ bgcolor: "rgba(255, 234, 223, 0.3)", p: { xs: 2, md: 8 } }}
          >
            <Box>
              <Typography sx={{ fontSize: 30, fontWeight: "bold", color: "#6d1675", textAlign: "center" }}>
                Popular
                <span style={{ color: "#ffc20f" }}> Courses </span>{" "}
              </Typography>

              {/* Divider with flower */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  maxWidth: 300,
                  mx: "auto",
                }}
              >
                <Box sx={{ flex: 1, height: 3, bgcolor: "#6d1675" }} />
                <Box sx={{ px: 2, display: "flex", alignItems: "center" }}>
                  <LocalFloristIcon sx={{ fontSize: 28, color: "#ffc20f" }} />
                </Box>
                <Box sx={{ flex: 1, height: 3, bgcolor: "#6d1675" }} />
              </Box>

              <Grid container spacing={3} sx={{ mt: 5,justifyContent:'center' }}>
                {popular.map((course, index) => (
                  <Grid
                    component={motion.div}
                    variants={itemVariants}
                    item
                    xs={12}
                    md={3}
                    sm={6}
                    key={index}
                    sx={{ mb: 5 }}
                  >
                    <motion.div
                      whileHover={{
                        scale: 1.05,
                        boxShadow: "0 10px 25px rgba(109, 22, 117, 0.3)"
                      }}
                      transition={{ duration: 0.3 }}
                    >
                      <Card
                        sx={{
                          height: 320,
                          borderRadius: 3,
                          boxShadow: "0 5px 15px rgba(109, 22, 117, 0.15)",
                          cursor: "pointer",
                          display: "flex",
                          flexDirection: "column",
                          background: "linear-gradient(145deg, #ffffff 0%, #f9f5fa 100%)",
                          border: "1px solid rgba(109, 22, 117, 0.1)",
                          overflow: "visible",
                          transition: "all 0.3s ease-in-out",
                          '&:hover': {
                            boxShadow: "0 12px 30px rgba(109, 22, 117, 0.25)"
                          }
                        }}
                      >
                        {/* Image container with decorative elements */}
                        <Box sx={{ position: "relative", p: 1 }}>
                          <Box
                            sx={{
                              position: "absolute",
                              top: -10,
                              right: -10,
                              width: 30,
                              height: 30,
                              borderRadius: "50%",
                              backgroundColor: "#ffc20f",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxShadow: "0 3px 10px rgba(255, 194, 15, 0.4)",
                              zIndex: 2
                            }}
                          >
                            <Typography variant="caption" sx={{ fontWeight: "bold", color: "#6d1675" }}>
                              {index + 1}
                            </Typography>
                          </Box>

                          <Box
                            sx={{
                              borderRadius: 2,
                              overflow: "hidden",
                              position: "relative",
                              boxShadow: "0 5px 15px rgba(0,0,0,0.1)"
                            }}
                          >
                            <motion.img
                              src={course.image}
                              alt={course.title}
                              style={{
                                width: "100%",
                                height: 150,
                                objectFit: "cover",
                              }}
                              whileHover={{ scale: 1.1 }}
                              transition={{ duration: 0.4 }}
                            />
                            <Box
                              sx={{
                                position: "absolute",
                                bottom: 0,
                                left: 0,
                                right: 0,
                                height: "30%",
                                background: "linear-gradient(to top, rgba(109, 22, 117, 0.7), transparent)",
                                pointerEvents: "none"
                              }}
                            />
                          </Box>
                        </Box>

                        <CardContent sx={{ textAlign: "left", p: 2, pt: 1, flexGrow: 1, display: "flex", flexDirection: "column" }}>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              alignItems: "flex-start",
                              mb: 1
                            }}
                          >
                            <Typography
                              variant="subtitle1"
                              sx={{
                                fontWeight: "bold",
                                color: "#6d1675",
                                fontSize: 14,
                                maxWidth: 180,
                                background: "linear-gradient(to right, #6d1675, #8a29a3)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                backgroundClip: "text",
                              }}
                            >
                              {course.title}
                            </Typography>

                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                backgroundColor: "rgba(255, 194, 15, 0.2)",
                                borderRadius: 2,
                                px: 1,
                                py: 0.5
                              }}
                            >
                              <VisibilityIcon
                                sx={{
                                  fontSize: 14,
                                  color: "#6d1675",
                                  mr: 0.5,
                                }}
                              />
                              <Typography
                                variant="body2"
                                sx={{ color: "#6d1675", fontWeight: "medium", fontSize: 12 }}
                              >
                                {course.views}
                              </Typography>
                            </Box>
                          </Box>

                          {/* Channel */}
                          <Box sx={{ display: "flex", alignItems: "center", mt: "auto" }}>
                            <Box
                              sx={{
                                width: 24,
                                height: 24,
                                borderRadius: "50%",
                                backgroundColor: "#ffc20f",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                mr: 1,
                                boxShadow: "0 2px 5px rgba(255, 194, 15, 0.5)"
                              }}
                            >
                              <Typography variant="caption" sx={{ color: "#6d1675", fontWeight: "bold" }}>
                                {course.channel.charAt(0)}
                              </Typography>
                            </Box>
                            <Typography
                              variant="body2"
                              sx={{
                                color: "text.secondary",
                                fontSize: 13,
                                fontWeight: 500
                              }}
                            >
                              {course.channel}
                            </Typography>
                          </Box>

                          {/* Progress bar or rating */}
                          <Box sx={{ mt: 1.5 }}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 0.5 }}>
                              <Typography variant="caption" sx={{ color: "#6d1675", fontWeight: "medium" }}>
                                Rating:
                              </Typography>
                              <Typography variant="caption" sx={{ color: "#6d1675", fontWeight: "bold" }}>
                                {course.rating || "4.5/5"}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                width: "100%",
                                height: 6,
                                backgroundColor: "rgba(109, 22, 117, 0.1)",
                                borderRadius: 3,
                                overflow: "hidden"
                              }}
                            >
                              <Box
                                sx={{
                                  width: "90%",
                                  height: "100%",
                                  backgroundColor: "#ffc20f",
                                  borderRadius: 3
                                }}
                              />
                            </Box>
                          </Box>
                        </CardContent>
                      </Card>
                    </motion.div>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Box>
        </Box>
        <Footer />
      </Box>
    </>
  );
};

export default Courses;

